import { Box } from "@chakra-ui/react";
import { InputField } from "components/input-field";
import { UsuarioBanco } from "../page";
import { dropdownBancos } from "../consts";
import { UsuarioBancoErrors } from ".";
import { useApplicationContext } from "contexts/ApplicationContext";
import { InputSearch } from "components/input-search";
import { Text } from "@chakra-ui/react";

export function RefinSaqueAndDigitadorFields({
  modalData,
  onChangeUsuarioBancoDialog,
  errors,
  isUpdate,
}: {
  modalData: UsuarioBanco;
  onChangeUsuarioBancoDialog: (
    field: keyof UsuarioBanco,
    value: string
  ) => void;
  errors: UsuarioBancoErrors;
  isUpdate: boolean;
}) {
  const { user } = useApplicationContext();

  const bancoOptions = isUpdate
    ? dropdownBancos.sort((a, b) =>
        a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" })
      )
    : dropdownBancos
        .filter((crr) => crr.value !== "CETELEM")
        .sort((a, b) =>
          a.name.localeCompare(b.name, "pt-BR", {
            sensitivity: "base",
          })
        );

  let bancoSelected =
    bancoOptions.find((option) => option.value === modalData.banco)?.name || "";

  return (
    <>
      <Box mb="15px">
        <Text mb="8px" fontSize="sm" fontWeight="medium">
          Banco
        </Text>

        <InputSearch
          value={bancoSelected}
          onChange={(value) => {
            onChangeUsuarioBancoDialog("banco", value);
            bancoSelected =
              bancoOptions.find((option) => option.value === value)?.name || "";
          }}
          options={bancoOptions}
          inputProps={{
            placeholder: "Selecione",
            onBlur: (e) => {
              e.target.value = bancoSelected;
            },
          }}
          checkIsInclude={(option) => option.value === modalData.banco}
          errorMessage={errors.banco ? "Selecione um banco" : undefined}
          openOnFocus
          partialSearch
          closeOnSelect
        />
      </Box>
      {!["TA_QUITADO_BMP", "TA_QUITADO_ZIPDIN"].includes(modalData.banco) ? (
        <>
          <Box mb="15px">
            <InputField
              title="Usuário"
              value={modalData.username}
              onChange={(e) =>
                onChangeUsuarioBancoDialog("username", e.target.value)
              }
              errorMessage={errors.username ? "Informe um usuário" : undefined}
            />
          </Box>
          <Box mb="15px">
            <InputField
              title="Senha"
              value={modalData.password}
              onChange={(e) =>
                onChangeUsuarioBancoDialog("password", e.target.value)
              }
              errorMessage={errors.password ? "Informe uma senha" : undefined}
            />
          </Box>
        </>
      ) : (
        <Box mb="15px">
          <InputField
            title="Api Key"
            value={modalData.apiKey}
            onChange={(e) =>
              onChangeUsuarioBancoDialog("apiKey", e.target.value)
            }
            errorMessage={errors.apiKey ? "Informe uma Api Key" : undefined}
          />
        </Box>
      )}
      {modalData.banco === "BANRISUL" ? (
        <Box mb="15px">
          <InputField
            title="Token Módulo"
            value={modalData.tokenModulo}
            onChange={(e) =>
              onChangeUsuarioBancoDialog("tokenModulo", e.target.value)
            }
            errorMessage={
              errors.tokenModulo ? "Informe um token módulo" : undefined
            }
          />
        </Box>
      ) : null}
      {modalData.banco === "PAN" ? (
        <Box mb="15px">
          <InputField
            title="Código Promotora"
            value={modalData.codigoPromotora}
            onChange={(e) =>
              onChangeUsuarioBancoDialog(
                "codigoPromotora",
                e.target.value.trim()
              )
            }
            errorMessage={
              errors.codigoPromotora
                ? "Informe o código da promotora"
                : undefined
            }
          />
        </Box>
      ) : null}
      {modalData.banco === "FACTA" &&
      user.userData.customerCodigoNova?.startsWith("8818") ? (
        <Box mb="15px">
          <InputField
            title="Código Master"
            value={modalData.codigoPromotora}
            onChange={(e) =>
              onChangeUsuarioBancoDialog(
                "codigoPromotora",
                e.target.value.trim()
              )
            }
            errorMessage={errors.codigoPromotora ? "Código Master" : undefined}
          />
        </Box>
      ) : null}
      {modalData.banco === "SANTANDER" ? (
        <Box mb="15px">
          <InputField
            title="Nome Promotora"
            value={modalData.nomePromotora}
            onChange={(e) =>
              onChangeUsuarioBancoDialog("nomePromotora", e.target.value.trim())
            }
            errorMessage={
              errors.nomePromotora ? "Informe o nome da promotora" : undefined
            }
          />
        </Box>
      ) : null}
      {modalData.ativoDigitador && modalData.banco === "BMG" ? (
        <Box mb="15px">
          <InputField
            title={"Código Loja"}
            value={modalData.codigoDigitador}
            onChange={(e) =>
              onChangeUsuarioBancoDialog("codigoDigitador", e.target.value)
            }
            errorMessage={
              errors.codigoDigitador
                ? "Preencha os campos corretamente"
                : undefined
            }
          />
        </Box>
      ) : null}
      {modalData.ativoDigitador &&
      ![
        "BMG",
        "MASTER",
        "VCTEX",
        "LOTUS_TAYA",
        "SANTANDER",
        "BRADESCO_DIGIO",
        "TA_QUITADO_BMP",
        "TA_QUITADO_ZIPDIN",
        "NOVO_SAQUE",
        "X3_BMP",
        "PRESENCA",
        "ICRED",
        "VCTEX_CDC",
        "VCTEX_QITECH",
        "V8_BMS",
        "V8_QITECH",
        "V8_CARTOS",
      ].includes(modalData.banco) ? (
        <>
          <Box mb="15px">
            <InputField
              title={
                ["PAN", "TWO_S_CONSIG"].includes(modalData.banco)
                  ? "CPF Usuário Certificado"
                  : modalData.banco === "C6" && modalData.ativoDigitador
                  ? "Código Digitador"
                  : "Login Certificado"
              }
              value={modalData.cpfUsuarioCertificado}
              onChange={(e) =>
                onChangeUsuarioBancoDialog(
                  "cpfUsuarioCertificado",
                  e.target.value
                )
              }
              errorMessage={
                errors.cpfUsuarioCertificado
                  ? `Informe um ${
                      ["PAN", "TWO_S_CONSIG"].includes(modalData.banco)
                        ? "CPF Usuário Certificado"
                        : modalData.banco === "C6" && modalData.ativoDigitador
                        ? "Código Digitador"
                        : "Login Certificado"
                    }`
                  : undefined
              }
            />
          </Box>
          {modalData.banco === "PAN" ? (
            <>
              <Box mb="15px">
                <InputField
                  title="Nome Usuário Certificado"
                  value={modalData.nomeUsuarioCertificado || ""}
                  onChange={(e) =>
                    onChangeUsuarioBancoDialog(
                      "nomeUsuarioCertificado",
                      e.target.value
                    )
                  }
                  errorMessage={
                    errors.nomeUsuarioCertificado
                      ? "Informe um Nome Usuário Certificado"
                      : undefined
                  }
                />
              </Box>
              <Box mb="15px">
                <InputField
                  title="Código Digitador"
                  value={modalData.codigoDigitador}
                  onChange={(e) =>
                    onChangeUsuarioBancoDialog(
                      "codigoDigitador",
                      e.target.value
                    )
                  }
                  errorMessage={
                    errors.codigoDigitador
                      ? "Informe um Código Digitador"
                      : undefined
                  }
                />
              </Box>
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}
